export const contactItems = [
  {
    header: 'team@policygenius.com',
    icon: 'email',
    text: '24/7 - Available when you need us',
    href: 'mailto:team@policygenius.com'
  },
  {
    header: '1-855-695-2255',
    icon: 'phone',
    text: 'Monday-Thursday | 9am-11pm ET<br/>Friday | 9am-8pm ET<br/>Saturday | 9am-9pm ET<br/>Sunday | 10am-9pm ET',
    href: 'tel:1-855-695-2255'
  },
  {
    header: 'Live chat',
    icon: 'chat',
  },
];



// WEBPACK FOOTER //
// ../src/templates/Footer/data/contact.js